export default "__VITE_ASSET__BtHSq3GV__"